import { Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import {
    FUNCTIONARIES_SWITCHBOARD,
    FUNCTIONARIES_SWITCHBOARD_DETAIL,
    FUNCTIONARIES_SWITCHBOARD_EDIT,
    FUNCTIONARIES_SWITCHBOARD_NEW,
} from '../../../../../routes/paths';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import FormView from '../../../../components/views/formView';
import { FunctionariesSwitchData } from './Data';
import { useFunctionariesSwitchForm } from './hook';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { FunctionariesSwitchHistorical } from '../historical';
import { RootState } from '../../../../../redux/store';

export const FunctionariesSwitchForm = () => {
    const {
        functionarieSwitch,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikFunctionariesSwitchData,
        functionariesSwitchHistorical,
        showHistorical,
        setShowHistorical,
    } = useFunctionariesSwitchForm();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const isAdmin = type === 'admin';

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    functionarieSwitch && functionarieSwitch.id
                        ? 'Editar Funcionarios Conmutador'
                        : 'Crear Funcionarios Conmutador'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={functionarieSwitch?.id || ''}
                        buttonCreate={{
                            show: Boolean(functionarieSwitch?.id),
                            route: FUNCTIONARIES_SWITCHBOARD_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FUNCTIONARIES_SWITCHBOARD,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: FUNCTIONARIES_SWITCHBOARD_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: FUNCTIONARIES_SWITCHBOARD_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(functionarieSwitch?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />

            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <FunctionariesSwitchHistorical
                        historical={functionariesSwitchHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}

            <FunctionariesSwitchData
                data={functionarieSwitch}
                isAdmin={isAdmin}
                onChangeFormik={(formik) =>
                    setFormikFunctionariesSwitchData(formik)
                }
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
